import { createContext } from 'react';
import { Property, SimpleSupplierProps } from '@/custom-types';
import {
  CreateIncidentInput,
  IncidentCategoryOption,
  IncidentTypeOption,
  PriorityOption,
} from '@/graphql/generated';

export type CreateIncidentActionsProps = {
  setProperty: (property: Property) => void
  setUnity: (unityId: string | null) => void
  setType: (type: IncidentTypeOption) => void
  setCategory: (category: IncidentCategoryOption) => void
  setPriority: (priority: PriorityOption) => void
  setStartDate: (date: string | null) => void
  setEndDate: (date: string | null) => void
  setNote: (description: string) => void
  setSupplier: (supplier: SimpleSupplierProps | null) => void
  setSubject: (subject: string | null) => void
  setPictures: (pictures: File[]) => void
  setVideos: (videos: File[]) => void
  state: CreateIncidentInput
  pictures: File[]
  videos: File[]
  setButtonDisabled: () => void
  setButtonEnabled: () => void
  buttonState: boolean
  property: Property | null
  supplier: SimpleSupplierProps | null
}

export const CreateIncidendContext = createContext<CreateIncidentActionsProps | null>(null)